




























































































































































































































































































































































































import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
    InspirationListItem,
    Inspiration,
    InspirationImage,
    InspirationImageArticleMap,
    InspirationArticle,
    InspirationFilters
} from '@/models/Inspiration';
import http from '@/services/Http';
import ImageHotspots from './ImageHotspots.vue';
import ConfigBuyButton from '../Product/Configurator/ConfigBuyButton.vue';

@Component({
    components: {
        ImageHotspots,
        ConfigBuyButton
    }
})
export default class InspirationList extends Vue {
    get inspirationListFiltered() {
        return this.inspirationList.filter(x => x.Visible);
    }
    protected inspirationList!: InspirationListItem[];
    protected selectedInspiration!: Inspiration;
    protected activeImage!: InspirationImage;
    protected showSelected: boolean = false;
    protected showSideboard: boolean = false;
    protected selectedImageIndex: number = 0;
    protected filterOptions!: InspirationFilters;
    protected selectedFilterOptions!: InspirationFilters;
    protected selectedCounter: number = 0;
    protected toogleFilterMobile: boolean = false;
    protected pageTitle!: string;
    protected pageDescription!: string;
    protected pageUrl: string = '';
    protected originalIntro: string = '';
    protected lastClickedNode = null;

    constructor() {
        super();
        this.inspirationList = JSON.parse(this.$attrs['data-content']);
        this.filterOptions = {
            BaseColors: [],
            DoorFamilies: [],
            DoorTypes: [],
            Series: []
        };
        this.selectedFilterOptions = {
            BaseColors: [],
            DoorFamilies: [],
            DoorTypes: [],
            Series: []
        };

        this.$attrs['data-content'] = '';
    }

    destroyed() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    private mounted() {
        this.pageTitle = document.title;
        this.pageDescription = this.getMetaValue('description');
        this.pageUrl = this.getPageUrl();
        this.getFilterOptions('BaseColors');
        this.getFilterOptions('DoorFamilies');
        this.getFilterOptions('DoorTypes');
        this.getFilterOptions('Series');
        this.checkQuery();
        if (this.selectedCounter === 0) {
            this.selectedCounter = this.inspirationList.length;
        }

        document.addEventListener('mousedown', this.clickHandler);

        //   console.log(this.inspirationList);
    }

    private showImageHotspots(image: InspirationImage) {
        this.activeImage = image;
        // if (window.innerWidth >= 600) {
        this.$modal.show(
            ImageHotspots,
            {
                inspiration: this.selectedInspiration,
                initialImage: this.activeImage
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
        // }
    }

    private getPageUrl(): string {
        const url = window.location.href.split('?')[0];
        // console.log('getPageUrl', url);
        return url;
    }

    private toggleFilter(e: any) {
        const filter = e.currentTarget;

        if (!filter.classList.contains('open')) {
            this.closeFilters();
            filter.classList.add('open');
        } else if (filter.classList.contains('open') && e.srcElement.classList.contains('toggle-arrow')) {
            this.closeFilters();
        }
    }
    private showClearFilter(): boolean {
        if (
            this.selectedFilterOptions.BaseColors.length > 0 ||
            this.selectedFilterOptions.DoorFamilies.length > 0 ||
            this.selectedFilterOptions.DoorTypes.length > 0 ||
            this.selectedFilterOptions.Series.length > 0
        ) {
            return true;
        }
        return false;
    }
    private closeFilters() {
        const filters = document.querySelectorAll('.filter-item');
        filters.forEach((filter: any) => {
            filter.classList.remove('open');
        });
    }

    private selectedFilter(option: string, filter: string): boolean {
        if (this.selectedFilterOptions[filter].indexOf(option) !== -1) {
            return true;
        }
        return false;
    }
    private runFilters() {
        const baseColors = this.selectedFilterOptions.BaseColors;
        const doorFamilies = this.selectedFilterOptions.DoorFamilies;
        const doorTypes = this.selectedFilterOptions.DoorTypes;
        const series = this.selectedFilterOptions.Series;
        let count = 0;

        this.inspirationList.forEach(item => {
            item.Visible = true;

            if (baseColors && baseColors.length > 0) {
                item.Visible = item.BaseColors.some(val => baseColors.indexOf(val) !== -1);
            }

            if (item.Visible && doorFamilies && doorFamilies.length > 0) {
                item.Visible = item.DoorFamilies.some(val => doorFamilies.indexOf(val) !== -1);
            }

            if (item.Visible && doorTypes && doorTypes.length > 0) {
                item.Visible = item.DoorTypes.some(val => doorTypes.indexOf(val) !== -1);
            }

            if (item.Visible && series && series.length > 0) {
                item.Visible = item.Series.some(val => series.indexOf(val) !== -1);
            }

            if (item.Visible) {
                count++;
            }
        });

        this.selectedCounter = count;
    }
    private selectFilter(option: string, filter: string) {
        const index = this.selectedFilterOptions[filter].indexOf(option);
        if (index === -1) {
            this.selectedFilterOptions[filter].push(option);
        } else {
            this.selectedFilterOptions[filter].splice(index, 1);
        }

        this.runFilters();
        this.setQuerystrings(filter, this.selectedFilterOptions[filter].toString());
    }
    private clearFilter() {
        this.selectedFilterOptions = {
            BaseColors: [],
            DoorFamilies: [],
            DoorTypes: [],
            Series: []
        };

        this.runFilters();
        this.setQuerystrings('BaseColors', undefined);
        this.setQuerystrings('DoorFamilies', undefined);
        this.setQuerystrings('DoorTypes', undefined);
        this.setQuerystrings('Series', undefined);
    }
    private getFilterOptions(filter: string) {
        this.inspirationList.forEach(inspiration => {
            inspiration[filter].forEach(item => {
                if (this.filterOptions[filter].indexOf(item) === -1) {
                    this.filterOptions[filter].push(item);
                }
                this.filterOptions[filter].sort();
            });
        });
    }

    private getLinkWithQuerystring(id: string) {
        if (id != null && id != '') {
            return this.pageUrl + '?id=' + id;
        }
        return this.pageUrl;
    }

    private setQuerystrings(att: string, value?: string) {
        const currentQuery = JSON.parse(JSON.stringify(this.$route.query));

        if (value !== undefined || currentQuery[att] != undefined) {
            currentQuery[att] = value;
            this.$router.replace({
                path: this.$route.params[0],
                query: currentQuery
            });
        }
    }
    private setTitleAndMetaTags(name: string, id: string, description: string, metaDescription: string) {
        // console.log('setTitleAndMetaTags', name, id);
        let title = '';
        let heading = '';

        if (name != '') {
            title = name + ' | ' + this.pageTitle;
            heading = name;
        } else {
            title = heading = this.pageTitle;
        }

        const url = this.getLinkWithQuerystring(id);
        const links = document.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            if (links[i].getAttribute('rel') === 'canonical') {
                links[i].setAttribute('href', url);
            }
        }

        document.title = title;

        const metaTags = document.head.getElementsByTagName('meta');
        for (let i = 0; i < metaTags.length; i++) {
            if (metaTags[i].getAttribute('property') === 'og:title') {
                metaTags[i].setAttribute('content', title);
            }

            if (metaTags[i].getAttribute('property') === 'og:url') {
                metaTags[i].setAttribute('content', url);
            }

            if (metaTags[i].getAttribute('property') === 'og:description') {
                metaTags[i].setAttribute('content', metaDescription);
            }

            if (metaTags[i].getAttribute('name') === 'description') {
                metaTags[i].setAttribute('content', metaDescription);
            }
        }
        const headingElm = document.querySelector('#inspirationsHeadline');
        const descriptionElm = document.querySelector('.inspiration-page .intro .p');
        if (headingElm !== null) {
            headingElm.innerHTML = heading.split('|')[0];
        }
        if (descriptionElm !== null) {
            if (this.originalIntro === '') {
                this.originalIntro = descriptionElm.innerHTML;
            }
            if (name !== '') {
                descriptionElm.innerHTML = description;
            } else {
                descriptionElm.innerHTML = this.originalIntro;
            }
        }
    }

    // private setTitle(name: string) {
    //     if (name != '') {
    //         document.title = name + ' | ' + this.pageTitle;
    //     } else {
    //         document.title = this.pageTitle;
    //     }
    // }
    private selectedImage(index: number) {
        const element = document.getElementById('image-' + index);
        if (element) {
            const elementContainer = document.querySelector('#scroller');
            const offsetLeft = element.offsetLeft;
            if (elementContainer) {
                elementContainer.scrollTo({
                    left: offsetLeft
                });
            }
        }
        this.scrollTo('sideboard-top');
    }
    private chechQueryByFilter(filter: string) {
        if (this.$route.query[filter] != null) {
            const items: string[] = this.$route.query[filter].toString().split(',');
            items.forEach(element => {
                this.selectFilter(element, filter);
            });
        }
    }
    private checkQuery() {
        this.chechQueryByFilter('BaseColors');
        this.chechQueryByFilter('DoorFamilies');
        this.chechQueryByFilter('DoorTypes');
        this.chechQueryByFilter('Series');

        if (this.$route.query.id) {
            this.getInspiration(this.$route.query.id);
        }
    }
    private removeBodyClass() {
        const body = document.body;

        if (body.classList.contains('body-slided')) {
            body.classList.remove('body-slided');
        }
    }
    private addBodyClass() {
        const body = document.body;
        if (!body.classList.contains('body-slided')) {
            body.classList.add('body-slided');
        }
    }
    private changeImage(n: number) {
        const imagesLength = this.selectedInspiration.images.length;
        this.selectedImageIndex = (((this.selectedImageIndex + n) % imagesLength) + imagesLength) % imagesLength;
    }

    private clickHandler(e: any) {
        this.lastClickedNode = e.target;
        const sideBoard = document.querySelector('.inspiration-images__sideboard');
        const modalWindow = document.getElementById('modals-container');

        if (sideBoard && !sideBoard.contains(this.lastClickedNode) && (!modalWindow || !modalWindow.children.length)) {
            this.closeSideboard();
        }
    }
    private closeSideboard() {
        this.removeBodyClass();
        this.showSideboard = false;
        this.showSelected = false;
        this.setQuerystrings('id', undefined);
        this.setTitleAndMetaTags('', '', this.pageDescription, this.pageDescription);
    }
    private openDropdown(e: any) {
        const dropdown = e.currentTarget;

        if (!dropdown.classList.contains('open')) {
            this.closeDropdown();
            dropdown.classList.add('open');
        } else if (dropdown.classList.contains('open')) {
            this.closeDropdown();
        }
    }
    private closeDropdown() {
        const dropdowns = document.querySelectorAll('.social-item');
        dropdowns.forEach((dropdown: any) => {
            dropdown.classList.remove('open');
        });
    }
    private copyLink(e: any) {
        const linkElem = e.currentTarget;
        const url = linkElem.getAttribute('url');
        const el = document.createElement('textarea');
        el.value = url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
    private scroll(adjust: number) {
        const element = document.querySelector('#scroller');
        let elementWidth: number = 400 * adjust;
        let elementMargin: number = 20;

        if (element != null && element.childNodes != null && element.childNodes.length > 0) {
            // @ts-ignore
            const li = element.childNodes[0];

            if (li != null) {
                // @ts-ignore
                const style = window.getComputedStyle(li);
                elementMargin = Number(style.paddingRight.replace('px', ''));
            }

            // @ts-ignore
            elementWidth = (element.offsetWidth + elementMargin * 2) * adjust;

            if (adjust == 0) {
                element.scrollLeft = 0;
            } else {
                element.scrollTo({
                    left: element.scrollLeft + elementWidth,
                    behavior: 'smooth'
                });
            }
        }
    }

    private getMetaValue(metaName: string): string {
        const metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                if (metas[i].getAttribute('content') != null) {
                    // @ts-ignore
                    return metas[i].getAttribute('content');
                }
            }
        }

        return '';
    }

    private getInspiration(id: any) {
        this.addBodyClass();
        this.showSideboard = true;
        this.showSelected = false;
        this.setQuerystrings('id', id);

        if (id != null) {
            const request = {
                Id: id
            };

            const requestContext = (window as any).__litium.requestContext;

            axios({
                method: 'post',
                url: `/api/inspiration`,
                data: request,
                headers: {
                    'litium-request-context': JSON.stringify(requestContext)
                }
            })
                .then((response: any) => {
                    this.selectedInspiration = response.data;
                    this.showSelected = true;
                    //  console.log(this.selectedInspiration);
                    this.setTitleAndMetaTags(
                        this.selectedInspiration.metaTitle,
                        this.selectedInspiration.id,
                        this.selectedInspiration.description,
                        this.selectedInspiration.metaDescription
                    );
                })
                .catch((response: any) => {
                    // handle error
                    // console.log('error', response);
                });
        }
    }
    private scrollTo(id: any) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }
}
